// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2HnwS","balanceDisclaimer":"posDashboard_balanceDisclaimer__2BlWZ"};